import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/icons/times-circle.svg'


const _withScopeId = n => (_pushScopeId("data-v-6da6ea1f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "close-button"
}, null, -1))




export default {
  __name: 'TypePicker',
  props: { modelValue: {} },
  emits: ['update:modelValue', 'close', 'destroy'],
  setup(__props, { emit: emits }) {





function emitChoice (choice) {
  console.log(choice)
  emits('update:modelValue', choice)
}

return (_ctx, _cache) => {
  const _component_unicon = _resolveComponent("unicon")

  return (_openBlock(), _createElementBlock("div", {
    class: "type-picker",
    onClick: _cache[7] || (_cache[7] = _withModifiers($event => (emits('close')), ["stop"]))
  }, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = () => emitChoice('glyph')),
      class: "menu-item",
      title: "glyph"
    }, [
      _createElementVNode("img", {
        src: require('../assets/glyphs/Any.svg')
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = () => emitChoice('then')),
      class: "menu-item",
      title: "sequence"
    }, " ; "),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = () => emitChoice('or')),
      class: "menu-item",
      title: "choice"
    }, " | "),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = () => emitChoice('and')),
      class: "menu-item",
      title: "parallel"
    }, " // "),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = () => emitChoice('seq_x')),
      class: "menu-item",
      title: "actuator variable"
    }, " x ∈ "),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = () => emitChoice('seq_y')),
      class: "menu-item",
      title: "receiver variable"
    }, " y ∈ "),
    _hoisted_2,
    _createElementVNode("button", {
      class: "delete-button",
      onClick: _cache[6] || (_cache[6] = $event => (emits('destroy')))
    }, [
      _createVNode(_component_unicon, { name: "trash-alt" })
    ])
  ]))
}
}

}